import { BrowserRouter } from 'react-router-dom';
import { GlobalStyle } from '@snsw-gel/react';
import { GlobalNav } from '@snsw/react-global-nav';
import AppThemeProvider from 'app/components/providers/AppThemeProvider';
import CommonErrorModal from 'app/components/modals/CommonErrorModal';
import CommonInfoModal from 'app/components/modals/CommonInfoModal';
import ScrollToTop from 'app/components/layout/ScrollToTop';
import AppRouter from 'app/routes';
import Auth from 'app/sharedServices/authentication/AuthContext';
import { FlowStateProvider } from 'app/contexts/FlowStateContext';
import { getStorageItem, setStorageItem } from 'app/sharedServices/storage/storage';
import UnderMaintenance from 'app/pages/maintenance/UnderMaintenance';
import { ReCAPTCHAPolicy } from './components/common/reCAPTCHA/reCAPTCHAPolicy';
import ReCAPTCHAModal from './components/modals/ReCAPTCHAModal';

const MAINTENANCE_MODE = process.env.MAINTENANCE_MODE === 'true';
const MAINTENANCE_BYPASS_KEY = 'dbcc_pvt';

// Detect bypass query param on initial load and persist to session
const params = new URLSearchParams(window.location.search);
if (params.get('bypass') === MAINTENANCE_BYPASS_KEY) {
  setStorageItem('maintenanceBypass', true, 'session');
}

const App: React.FC = () => {
  const isBypassed = getStorageItem('maintenanceBypass', 'session');

  if (MAINTENANCE_MODE && !isBypassed) {
    return (
      <AppThemeProvider>
        <GlobalNav>
          <UnderMaintenance />
        </GlobalNav>
      </AppThemeProvider>
    );
  }

  return (
    <AppThemeProvider>
      <BrowserRouter>
        <Auth>
          <FlowStateProvider>
            <ScrollToTop />
            <CommonInfoModal />
            <CommonErrorModal />
            <ReCAPTCHAModal />
            <AppRouter />
            <ReCAPTCHAPolicy />
          </FlowStateProvider>
        </Auth>
      </BrowserRouter>
    </AppThemeProvider>
  );
};

export default App;
